import React, { useState } from "react";
import { Form, Row, Col, Checkbox } from "antd";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch } from "react-instantsearch";
import AlgoliaInput from "../common/inputs/algoliaInput";

interface props {
  activeQuestion?: any;
  text?: any;
  formRef?: any;
  setRoutineProductError?: any;
  productItem?: any;
}

// const algoliaSearchKey: any = process.env.REACT_APP_ALGOLIA_SEARCH_KEY;
// const algoliaAppId: any = process.env.REACT_APP_ALGOLIA_APP_ID;

// console.log("algoliaSearchKey", algoliaAppId);

// const searchClient = algoliasearch(algoliaSearchKey, algoliaAppId);
const searchClient = algoliasearch(
  "LMBMXNMRJU",
  "83ccc95e4e1e9d82f0f4055c59bf544e"
);

const RoutineQuestions: React.FC<props> = (props) => {
  const { formRef } = props;
  const [isSameAsMorning, setIsSameAsMorning] = useState<boolean>(false);

  const handleCheckboxChange = (e: any) => {
    setIsSameAsMorning((prev) => !prev);
    if (e.target.checked) {
      const morningValues = props?.formRef?.getFieldsValue([
        "day_Cleanser",
        "day_Toner",
        "day_Serum",
        "day_Moisturizer",
        "day_Cleanser_brand",
        "day_Toner_brand",
        "day_Serum_brand",
        "day_Moisturizer_brand",
      ]);
      const nightFieldValues: any = {};
      Object.keys(morningValues).forEach((key) => {
        const nightKey = key.replace("day_", "night_");
        nightFieldValues[nightKey] = morningValues[key];
      });

      props?.formRef?.setFieldsValue(nightFieldValues);
    }
  };

  const splitArrayIntoColumns = (columns: number, data: any) => {
    const arrLength = data.length;
    // Calculate the number of rows needed
    const itemsPerColumn = Math.ceil(arrLength / columns);

    // Create an array of rows with corresponding items
    const rows = [];
    for (let i = 0; i < 2; i++) {
      const start = i * itemsPerColumn;
      const end = start + itemsPerColumn;
      rows.push(data.slice(start, end));
    }

    return rows;
  };

  const morningOptions = splitArrayIntoColumns(
    2,
    props?.activeQuestion?.options[0]?.productType
  );
  const nightOptions = splitArrayIntoColumns(
    2,
    props?.activeQuestion?.options[1]?.productType
  );

  return (
    <div className="answer-input-wrapper">
      <div className="routine-question" key={1}>
        <div className="routine-question__title-check">
          <h3>{props?.activeQuestion?.options[0]?.time}</h3>
        </div>
        <Row gutter={25}>
          {morningOptions.map((columns: any, index: any) => {
            return (
              <Col span={24} md={12} key={index}>
                {columns.map((productItem: any, index: any) => {
                  return (
                    <Form.Item
                      key={index}
                      name={`day_${productItem?.title}`}
                      rules={[
                        {
                          required: false,
                          message: "",
                        },
                      ]}
                    >
                      <InstantSearch
                        searchClient={searchClient}
                        indexName="products_index"
                      >
                        <AlgoliaInput
                          type="day"
                          placeholder={productItem?.title?.replace(/\d$/, "")}
                          handleSelection={(val?: any) => {
                            let name = val?.id
                              ? `${val?.name} -+ ${val?.id} -+ ${val.brand_name}`
                              : val?.name;
                            if (!val?.brand_name) {
                              name = val?.name;
                            }
                            formRef?.setFieldValue(
                              `day_${productItem?.title}`,
                              name
                            );
                            formRef?.setFieldValue(
                              `day_${productItem?.title}_brand`,
                              val?.brand_name
                            );
                          }}
                          defaultValue={formRef.getFieldValue(
                            `day_${productItem?.title}`
                          )}
                          brand={formRef.getFieldValue(
                            `day_${productItem?.title}_brand`
                          )}
                          formRef={formRef}
                          productItem={productItem}
                        />
                      </InstantSearch>
                    </Form.Item>
                  );
                })}
              </Col>
            );
          })}
        </Row>
      </div>
      <div className="routine-question" key={2}>
        <div className="routine-question__title-check">
          <h3>{props?.activeQuestion?.options[1]?.time}</h3>
          <Checkbox onChange={handleCheckboxChange}>Same As Morning</Checkbox>
        </div>

        <Row gutter={25}>
          {nightOptions.map((columns: any, index: any) => {
            return (
              <Col span={24} md={12} key={index}>
                {columns.map((productItem: any, index: any) => {
                  return (
                    <Form.Item
                      key={index}
                      name={`night_${productItem?.title}`}
                      rules={[
                        {
                          required: false,
                          message: "",
                        },
                      ]}
                    >
                      <InstantSearch
                        searchClient={searchClient}
                        indexName="products_index"
                      >
                        <AlgoliaInput
                          placeholder={
                            productItem?.title?.replace(/\d$/, "") +
                            " " +
                            productItem?.subTitle
                          }
                          productItem={productItem}
                          formRef={formRef}
                          brand={formRef.getFieldValue(
                            `night_${productItem?.title}_brand`
                          )}
                          type="night"
                          handleSelection={(val?: any) => {
                            let name = val?.id
                              ? `${val?.name} -+ ${val?.id} -+ ${val.brand_name}`
                              : val?.name;
                            if (!val?.brand_name) {
                              name = val?.name;
                              // return;
                            }
                            formRef?.setFieldValue(
                              `night_${productItem?.title}`,
                              name
                            );
                            formRef?.setFieldValue(
                              `night_${productItem?.title}_brand`,
                              val?.brand_name
                            );
                          }}
                          defaultValue={formRef.getFieldValue(
                            `night_${productItem?.title}`
                          )}
                        />
                      </InstantSearch>
                    </Form.Item>
                  );
                })}
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default RoutineQuestions;
